var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1836_503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6931 18.6168H23.1006L24.4635 13.1649H19.6931V10.439C19.6931 9.03511 19.6931 7.71302 22.4191 7.71302H24.4635V3.13344C24.0192 3.07484 22.3414 2.94263 20.5695 2.94263C16.8691 2.94263 14.2413 5.20107 14.2413 9.34859V13.1649H10.1523V18.6168H14.2413V30.202H19.6931V18.6168Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1836_503"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.7113,
    height: 32.7113,
    fill: "white",
    transform: "translate(0.609375 0.216797)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.6381dfa1a1080cd98abbdbddbbfb89af.svg";
export { ForwardRef as ReactComponent };